import Header from "../header/Header";
import Location from "../location/Location";

function Home(props) {

    return(
        <div>
            <Header />
            <Location />
        </div>
    );
    
}

export default Home;